import React, { useCallback, useEffect, useState } from 'react';
import { Spinner } from '../../../components/UI';
import { api, MarketplaceAppCatalogDto, MarketplaceAppDetailDto, TenantAppInstallationDto } from '../../../services/api';
import AppBrowseView from './AppBrowseView';
import AppDetailView from './AppDetailView';

export default function AppMarketplacePanel() {
    const [catalog, setCatalog] = useState<MarketplaceAppCatalogDto[] | null>(null);
    const [installed, setInstalled] = useState<TenantAppInstallationDto[]>([]);
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [detail, setDetail] = useState<MarketplaceAppDetailDto | null>(null);

    const loadCatalog = useCallback(async () => {
        const [c, i] = await Promise.all([api.getMarketplaceCatalog(), api.getInstalledApps()]);
        setCatalog(c);
        setInstalled(i);
    }, []);

    useEffect(() => { loadCatalog(); }, [loadCatalog]);

    useEffect(() => {
        if (!selectedId) { setDetail(null); return; }
        api.getMarketplaceAppDetail(selectedId).then(setDetail).catch(() => setDetail(null));
    }, [selectedId]);

    const refreshAll = useCallback(async () => {
        await loadCatalog();
        if (selectedId) setDetail(await api.getMarketplaceAppDetail(selectedId));
    }, [loadCatalog, selectedId]);

    if (!catalog) return <Spinner />;

    if (selectedId && detail) {
        const installation = installed.find(i => i.marketplaceAppId === selectedId);
        return (
            <AppDetailView
                app={detail}
                installation={installation}
                onBack={() => setSelectedId(null)}
                onChanged={refreshAll}
            />
        );
    }

    return <AppBrowseView apps={catalog} onSelect={setSelectedId} />;
}
